import { useEffect, useRef } from 'react';
import { useOnboarding } from '../../contexts/OnboardingContext';

const OnboardingFlowController = ({ currentUser, appState, startRequest }) => {
  const {
    isOnboardingActive,
    currentFlow,
    currentStep,
    startOnboarding,
    restartOnboarding,
    completeStep,
    updateAppState,
    stopOnboarding,
  } = useOnboarding();
  const lastStartTokenRef = useRef(null);

  useEffect(() => {
    if (!appState) {
      return;
    }

    updateAppState(appState);
  }, [appState, updateAppState]);

  useEffect(() => {
    if (!startRequest?.token || startRequest.token === lastStartTokenRef.current) {
      return;
    }

    lastStartTokenRef.current = startRequest.token;
    if (startRequest.force) {
      restartOnboarding(startRequest.flow, startRequest.startStep);
      return;
    }

    startOnboarding(startRequest.flow, startRequest.startStep);
  }, [restartOnboarding, startOnboarding, startRequest]);

  useEffect(() => {
    if (currentUser) {
      return;
    }

    stopOnboarding();
  }, [currentUser, stopOnboarding]);

  useEffect(() => {
    if (!isOnboardingActive || !currentStep) {
      return;
    }

    if (currentFlow === 'guest' && currentUser && !currentUser.email?.startsWith('guest_')) {
      stopOnboarding();
      return;
    }

    if (
      currentStep === 'project-selection' &&
      (
        appState?.projectOpening ||
        (appState?.editorVisible && (appState?.projectName || appState?.projectId)) ||
        (appState?.hasActiveProjectLoaded && !appState?.accountModalOpen && appState?.projectId)
      )
    ) {
      completeStep('project-selection');
      return;
    }

    if (currentStep === 'create-project' && appState?.projectSetupStarted) {
      completeStep('create-project');
      return;
    }

    if (currentStep === 'ai-interaction' && appState?.aiShowModeSelected) {
      completeStep('ai-interaction');
      return;
    }

  }, [appState, completeStep, currentFlow, currentStep, currentUser, isOnboardingActive, stopOnboarding]);

  return null;
};

export default OnboardingFlowController;
